/**
 * Categorias por sexo y peso corporal (seccion 6.4).
 * Existen desde el MVP (RF-CAT-01). Los umbrales son editables por el
 * administrador desde el panel (RF-ADM-08); aqui viven los valores por
 * defecto con los que se siembra la base de datos (RF-DEV-03).
 */

import type { GenderCategory, WeightClass } from '@/types/domain';

export interface WeightClassBand {
  code: WeightClass;
  /** Limite superior en kg, inclusive. `null` = sin limite (categoria Pesado). */
  maxKg: number | null;
}

/** Umbrales por defecto de la tabla de RF-CAT-03. */
export const WEIGHT_CLASSES: Record<'M' | 'F', WeightClassBand[]> = {
  M: [
    { code: 'LIGHT', maxKg: 67 },
    { code: 'MIDDLE', maxKg: 78 },
    { code: 'LIGHT_HEAVY', maxKg: 88 },
    { code: 'HEAVY', maxKg: null },
  ],
  F: [
    { code: 'LIGHT', maxKg: 54 },
    { code: 'MIDDLE', maxKg: 63 },
    { code: 'LIGHT_HEAVY', maxKg: 72 },
    { code: 'HEAVY', maxKg: null },
  ],
};

/**
 * La categoria Abierta (RF-CAT-04) no declara sexo y compite en clasificacion
 * propia. Se le aplica la tabla masculina solo para repartir el peso dentro de
 * su propia division; nunca puntua en Masculino ni en Femenino.
 */
export const OPEN_WEIGHT_REFERENCE: 'M' | 'F' = 'M';

export const GENDER_CATEGORIES: GenderCategory[] = ['M', 'F', 'OPEN'];

export const WEIGHT_CLASS_ORDER: WeightClass[] = ['LIGHT', 'MIDDLE', 'LIGHT_HEAVY', 'HEAVY'];

export const CATEGORY_RULES = {
  /**
   * Por debajo de este numero de participantes la categoria de peso se fusiona
   * con la contigua (RF-CAT-06). La division por sexo nunca se fusiona.
   */
  MIN_PARTICIPANTS_PER_CATEGORY: 5,
  /** Un cambio de peso cada 30 dias (RF-CAT-07). */
  WEIGHT_CHANGE_COOLDOWN_DAYS: 30,
  /** Un cambio de pais/ciudad cada 90 dias (RF-ONB-03). */
  LOCATION_CHANGE_COOLDOWN_DAYS: 90,
  /** Minimo de atletas para que una ciudad tenga ranking propio (RF-RANK-10). */
  MIN_ATHLETES_FOR_CITY_RANKING: 5,
} as const;
